import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-progress-spinner',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss'],
})
export class ProgressSpinnerComponent {
  diameterSize = 60;
  styleStr = '';

  @Input() set diameter(value: number) {
    if (value !== null) {
      this.diameterSize = value;
    }

    this.styleStr = `width: ${this.diameterSize}px; height: ${this.diameterSize}px`;
  }
}
